import React, { useState } from 'react';
import images from '../../../../assets/images';
import Button from 'devextreme-react/button';
import Tooltip from 'devextreme-react/tooltip';
import { useTranslation } from 'react-i18next';

export default function MeasuringToolIcon({
  onToggleMeasuring,
}: {
  onToggleMeasuring: (isActive: boolean) => void;
}) {
  const { t } = useTranslation();
  const [isMeasuringActive, setIsMeasuringActive] = useState(false);
  const handleClick = () => {
    const newState = !isMeasuringActive;
    setIsMeasuringActive(newState);
    onToggleMeasuring(newState);
  };

  return (
    <div className="measuring-tool-control-wrapper">
      <Button
        id="measuringTool"
        className="measuring-tool-button"
        onClick={handleClick}
      >
        <img src={images.measuringTool} alt="Measuring Tool" />
        <Tooltip
          target={'#measuringTool'}
          showEvent="dxhoverstart"
          hideEvent="dxhoverend"
          position="left"
          contentRender={() => {
            return (
              <div className="m-l-tooltip-wrapper">
                {t('tooltips.measuringTool')}
              </div>
            );
          }}
        />
      </Button>
    </div>
  );
}
